import type { ReactNode } from 'react';
import * as Sentry from '@sentry/react';
import { AlertCircle } from 'lucide-react';
import { Button } from './ui/Button';

/**
 * Last-resort boundary around the whole router. Before this existed a
 * render crash white-screened the app with nothing recorded; now the
 * user gets a reload prompt and the error reports to Sentry (when
 * configured; the boundary itself works either way).
 */
export function AppErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <Sentry.ErrorBoundary
      fallback={
        <main className="flex min-h-screen items-center justify-center bg-bg p-6 text-fg">
          <div className="max-w-md rounded-token-lg border border-line/10 bg-surface p-6 text-center shadow-token">
            <AlertCircle className="mx-auto h-8 w-8 text-danger" />
            <h1 className="mt-3 text-lg font-semibold">Something went wrong</h1>
            <p className="mt-1 text-sm text-fg-muted">
              The page hit an unexpected error. Reloading usually fixes it; if it
              keeps happening, let the team know what you were doing.
            </p>
            <Button className="mt-4" onClick={() => window.location.reload()}>
              Reload the page
            </Button>
          </div>
        </main>
      }
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
